export enum ETipoOrigemDadoDRE {
    CategoriaPlanoContas = 1,
    GrupoDRE = 2,
    VariavelSistema = 3,
}
